<template>
    <v-card v-show="totalItems > 0 || !apiEndpoint">
          <v-layout row wrap pl-3 pr-3>
              <v-flex xs12>
                  <slot v-if="filter" name="filterTrigger"></slot>
                  <v-text-field
                        v-else
                        append-icon="search"
                        label="Caută"
                        single-line
                        hide-details
                        v-model="search"
                    ></v-text-field>
              </v-flex>
          </v-layout>
          <slot name="filter"></slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            rows-per-page-text="Rezultate pe pagină"
            disable-initial-sort
            item-key="id"
            :hide-actions="!hasPagination"
            ref="table">

            <template slot="items" slot-scope="props">
                <tr @click="tableToggleRowExpand(props)">
                    <td class="line-height-2" v-for="(header, index) in headers" :key="index" v-html="displayRowData(props, header)"></td>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <v-card flat class="card-expanded">
                    <template>
                        <v-btn v-for="(action, index) in actions" :color="action.color" :key="index" flat @click.native.stop="onAction(action.event, props.item)">{{action.name}}</v-btn>
                    </template>
                </v-card>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import * as constants from '../constants';

export default {
  props: ['items', 'headers', 'entityName', 'isLoaded', 'actions', 'filter', 'apiEndpoint', 'staticData'],

  data() {
    return {
      search: '',
      newData: {
        id: null
      },
      loading: true,
      pagination: {},
      rowsPerPageItems: [5, 10, 25, 50, {'text': 'Tot', 'value': -1}],
      totalItems: 0
    };
  },

  watch: {
    pagination: {
      handler() {
        this.loadItems();
      },
      deep: true
    },

    filter() {
      this.loadItems();
    }
  },

  computed: {
    searchableColumns() {
      return this.headers.filter(i => i.searchable !== false);
    },

    hasPagination() {
      return this.totalItems > constants.ROWS_PER_PAGE;
    }
  },

  created() {
    this.pagination.rowsPerPage = constants.ROWS_PER_PAGE;
  },

  methods: {
    loadItems() {
      if (this.apiEndpoint) {
        this.loading = true;
        this.$emit('loading', (this.loading && this.totalItems === 0));
        this.$store.dispatch(`${this.apiEndpoint}/LOAD`,
          {filter: { search: this.search, ...this.filter, ...this.pagination }})
          .then((result) => {
            if (this.staticData) {
              this.$emit('staticItems', result.data);
            }
            this.totalItems = result.meta.total;
            this.loading = false;
            this.$emit('loading', (this.loading && this.totalItems === 0));
          });
      } else {
        this.loading = false;
        this.pagination.rowsPerPage = -1;
      }
    },

    tableToggleRowExpand(props) {
      props.expanded = !props.expanded;
    },

    onAction(event, item) {
      let eventData = {
        name: event,
        data: item
      };
      this.$emit('action', eventData);
    },

    displayRowData(props, header) {
      if (props.item[header.value] || props.item[header.value] === 0) {
        if (header.nestedValue) {
          let nestedValues = header.nestedValue.split('.');
          let rowData = { ...props.item };
          nestedValues.forEach(prop => {
            rowData = rowData[prop];
          });
          return rowData;
        } else if (header.format) {
          return header.format(props.item);
        } else {
          return props.item[header.value];
        }
      }
      return '';
    }
  }
};
</script>

<style>
  .line-height-2 {
    line-height: 2;
  }
</style>


// WEBPACK FOOTER //
// src/components/DataTable.vue